
/* Analytics */
export class Analytics {
    constructor() {
        this.dataLayer = window.dataLayer;
    };

    trackEvent(obj) {
        var category = obj.category || null,
            action = obj.action || null,
            label = obj.label || null,
            value = obj.value || null,
            nonint = obj.nonint || false;
        
        if (category !== null && action !== null && value !== null) {
            this.dataLayer.push({ // event
                'event': 'trackEvent',
                'eventCategory': category,
                'eventAction': action,
                'eventLabel': label,
                'eventValue': value,
                'eventNonInt': nonint
            });
        }
    }

    trackVirtualPageview(obj) {
        var path = obj.path || location.pathname;

        this.dataLayer.push({
            'event': 'trackVirtualPageview',
            'virtualPageview': path
        });
    }

};


// WEBPACK FOOTER //
// ./src/modules/analytics/index.js